<template>
    <div :class="`mb-2 room-detail card ${selected? 'selected': ''}`" @click="onClick">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <div>
                    <p :class="isMobile? 'mb-0 pr-1' : 'mb-0'" :style="isMobile? 'font-size: 0.7rem' : ''">{{name}}</p>
                    <small>{{trattamento}}</small>
                </div>
                <div class="d-flex">
                    <div v-if="isMobile" class="py-1">
                        <h5 v-if="!selected" :class="deltaPrice>0 ? 'text-danger more currency mr-2 nowrap' : 'text-danger minus currency mr-2 nowrap'">{{sign}}{{abs}} &euro;</h5>
                        <h6 v-else class="text-right text-uppercase currency">selezionato</h6>
                    </div>
                    <div v-else class="py-1">
                        <h4 v-if="!selected" :class="deltaPrice>0 ? 'more currency mr-2' : 'minus currency mr-2'">{{sign}}{{abs}} &euro;</h4>
                        <h5 v-else class="text-right text-uppercase">selezionato</h5>
                    </div>
                    <div>
                        <button v-if="!selected" @click="onClick" class="btn btn-outline-primary">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {roomHotelName} from '../../../../../utils/helper'
import MobileDetector from '../../../../common/MobileDetector'

export default {
  name: 'RoomDetail',
  mixins: [MobileDetector],
  props: {
    value: Object,
    group: Object
  },
  computed: {
    name: function () {
      return roomHotelName(this.value.roomInfo.description)
    },
    trattamento () {
      return this.value.roomInfo.treatment
    },
    selected: function () {
      return this.value.selected
    },
    deltaPrice: function () {
      const roomSelected = this.group.rooms.find(item => { return item.selected })
      return Math.round(this.value.price.venditaTotaleEuro - roomSelected.price.venditaTotaleEuro)
    },
    abs: function () {
      return Math.abs(this.deltaPrice)
    },
    sign: function () {
      if (this.deltaPrice === 0) return ''
      return this.deltaPrice >= 0 ? '+' : '-'
    }
  },
  methods: {
    onClick: function () {
      this.group.rooms.map(room => { room.selected = false })
      this.value.selected = true
      this.$emit('change', this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/hotel-panel/RoomDetail.vue